import React from 'react';
import {connect} from 'react-redux';
import CONSTANTS from './constants.js';
import instrumentCreator from './actionCreators'
import './SoundBox.scss'
const mapDispatchToProps =  (dispatch) => {
    return {
        instDispatch: value => dispatch(instrumentCreator(value)) 
    };
} 


class SoundBox extends React.Component{
    constructor(props){
        super(props);
        
        this.state = {
            audio: new Audio(props.sound.key),
            name: props.sound.name,
            audioUnPaused: true
        };
        this.playSound = this.playSound.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        
        
        

    }
    
    componentDidMount(){
        document.addEventListener("keydown", this.handleKeyPress);
    }
    componentWillUnmount(){
        document.removeEventListener("keydown", this.handleKeyPress);
  }
    handleKeyPress(e){
        if(e.key.toUpperCase() === this.props.keyPress){
            this.playSound();
        }
        
    }
    playSound(){
        let audio = this.state.audio;
        let el = document.getElementById(this.state.name);
        let audioEl = document.getElementById(this.state.name).lastElementChild;
        
        if(this.state.audioUnPaused){
            audioEl.pause();
            audioEl.currentTime = 0;
            audioEl.play();
            this.props.instDispatch(this.props.sound.name);
            
            el.style.color = 'black';
            window.setTimeout(()=>{
                el.style.color='red';
            },100);
            
            /*
            butEl.disabled = true;
            this.state.audioUnPaused = false;
            this.props.instDispatch(this.props.sound.name);
            
            window.setTimeout(()=>{
                audioEl.pause();
                audioEl.currentTime = 0;
                this.state.audioUnPaused = true;
                butEl.disabled = false;
            },150)
            */
        }
        
        
    }
    
    render(){
        return (
            <div className='SoundBox drum-pad' id={this.state.name} onClick = {this.playSound}>
                {this.props.keyPress}
                <audio id={this.props.keyPress} className = 'clip' src={this.props.sound.key}/>
            </div>
        );
    }
}


export default connect(CONSTANTS.mapStateToProps,mapDispatchToProps)(SoundBox);